import React from 'react'
import { connect } from 'react-redux'
import { Grid, Row, Table} from 'react-bootstrap'
import SearchBar from '../../components/SearchBar'
import Breadcrumbs from '../../components/Breadcrumbs'
import { fetchOrder } from '../../actions/order-actions'
import PropertyTitle from '../../components/PropertyTitle'
import Property from '../../components/Property'
import moment from 'moment'

class OrderItems extends React.Component {
  render() {
    return <div className='tablescontainer orders'>
      <Table striped>
        <thead>
          <tr>
            <th>ID</th>
            <th>WebshopID</th>
            <th>EAN</th>
            <th>Aantal</th>
            <th>Geactiveerd</th>
            <th>Licentietype</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {
            this.props.items.map( (item,i) => <tr key={i} onClick={()=>this.props.onClick(item.navisionId)}>
              <td>{item.navisionId}</td>
              <td>{item.webshopOrderItemId}</td>
              <td>{item.ean}</td>
              <td>{item.quantity}</td>
              <td>{item.activeLicenseQuantity}</td>
              <td>{item.licenseType}</td>
              <td>{item.email}</td>
            </tr>)
          }
        </tbody>
      </Table>
    </div>
  }

}

class OrderDetail extends React.Component {

  componentDidMount() {
    this.props.fetchOrder(this.props.match.params.id)
  }

  componentDidUpdate(oldProps) {
    if(this.props.match.params.id !== oldProps.match.params.id) {
      this.props.fetchOrder(this.props.match.params.id)
    }
  }

  search(query) {
    this.props.history.push(`/orders?query=${query}`)
  }

  showOrderItems = (id) => this.props.history.push(`/order/${this.props.order.id}/licenses/${id}`)

  render() {
    const order = this.props.order
    if (!order) {
      return null
    }
    return <Grid>
      <Breadcrumbs title='Order' />
      <SearchBar placeholder='Zoek order' callback={(query) => this.search(query)} />
      <Row>
        <div className='content'>
          <div>
            <span className='title'><b>Order</b></span>
          </div>
          <div>
            <PropertyTitle 
              icon='file-text-o' 
              text={order.navisionId} 
            />
            <Property 
              icon='calendar' 
              value={moment(order.date).format('DD-MM-YYYY')} 
              tooltipText='Orderdatum'
            />
            <Property 
              icon='address-card-o' 
              value={order.customer.name} 
              tooltipText='Klantnaam in Navision'
            />
            <Property 
              icon='dot-circle-o' 
              value={order.customer.navisionId} 
              tooltipText='ID binnen Navision'
            />
            <Property 
              icon='envelope-o' 
              value={order.customer.email} 
            />
          </div>
          <div>
            <PropertyTitle small text='Orderregels'/>
            <OrderItems 
              items={order.items} 
              order={this.props.match.params.id} 
              onClick={this.showOrderItems} 
            />
          </div>
        </div>
      </Row>
    </Grid>
  }
}

export default connect( state => { return { order: state.orders.detail } }, {fetchOrder})(OrderDetail)
